import {toString} from 'ui/keyboard';
import {toComputable} from 'shared/utils/number';

export function valueOf(state: KeyboardState): number {
  return toComputable(toString(state));
}
